import { render, staticRenderFns } from "./ReturnPointsList.vue?vue&type=template&id=c36686a4&"
import script from "./ReturnPointsList.vue?vue&type=script&lang=js&"
export * from "./ReturnPointsList.vue?vue&type=script&lang=js&"
import style0 from "./ReturnPointsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports